import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchFilingMembersTypes = getApiActionTypes('FILING_GROUPS/FETCH_FILING_MEMBERS');
export const updateFilingMembersTypes = getApiActionTypes('FILING_GROUPS/UPDATE_FILING_MEMBERS');
